import { Box, Button, Link, TextField, Tooltip, withStyles, Chip } from '@material-ui/core';
import Constant from '@/common/constant/Constant';
import { DropFile } from '@/component/common/DropFile';
import { useEffect, useState } from 'react';
import Utils from '@/common/utils/utils';
import Iframe from '@/component/common/Iframe';
import FormInputWithOnChange from '../common/form/input-with-onchange';
import RichTextEditor from './fieldUI/RichTextEditor';
import TextAreaWithOnChange from '../common/form/textarea-with-onchange';
import { EditFileUploaded } from '../common/EditFileUploaded';
import DataPickerInput from './allFieldItem/DataPickerInput';
import AITelephoneStartDatePicker from './allFieldItem/AITelephoneStartDatePicker';
import AITelephoneEndDatePicker from './allFieldItem/AITelephoneEndDatePicker';
import RenderTooltipTitles from './allFieldItem/RenderTooltipTitles';
import TextInput from './allFieldItem/TextInput'
import MenuTagInputNotAuthen from './allFieldItem/MenuTagInputNotAuthen';
import MenuTagInPutWithAuthen from './allFieldItem/MenuTagInputWithAuthen';
import MenuMasterKnowledgeTagInPutWithAuthen from './allFieldItem/MenuMasterKnowledgeTagInPutWithAuthen';
import MenuMasterKnowledgeTagInPutNotAuthen from './allFieldItem/MenuMasterKnowledgeTagInPutBaseNotAuthen';
import StatusFieldUI from '../formManagement/fieldUI/StatusFieldUI';
import TextInputWithChip from './allFieldItem/TextInputWithChip';
import MermaidFieldUI from './fieldUI/MermaidFieldUI';
import HtmlFieldUI from './fieldUI/HtmlFieldUI';
import MarkdownFieldUI from './fieldUI/MarkdownFieldUI';
import { I18n } from 'aws-amplify';
import { PropTypes } from 'prop-types';
import TelephoneCallStatusFieldUI from '../formManagement/fieldUI/TelephoneCallStatusFieldUI';
import TelephoneConstant from '@/common/constant/TelephoneConstant';

NumberInput.propTypes = {
    defaultValue: PropTypes.any,
    detailTicket: PropTypes.object
    // Add other props validations as needed
};

function NumberInput(props) {
    let unitPosition = props?.data?.structure?.unitPosition;
    let unit = props?.data?.structure?.unit ? props?.data?.structure?.unit : '';
    let integerOnly = props?.data?.structure?.integerOnly === true;

    const onKeyPress = evt => {
        if (evt.which === 69 || evt.which === 101) {
            evt.preventDefault();
        }
    };

    const handleOnPaste = e => {
        let textInput = e.clipboardData.getData('Text');
        if (textInput.includes('e') || textInput.includes('E')) e.preventDefault();
    };

    const handleEditTicket = e => {
        if (props?.setIsEdited) {
            props?.setIsEdited(true);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket()
            if(!props?.listFieldEdited?.includes(props?.name)){
                props?.setListFieldEdited([...props.listFieldEdited,props?.name])
            }
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
        }
    };

    return (
        <div className="form-addTicket">
            <div className="cell-prod-status gap-8">
                {props?.isTooltipTitle ? 
                    <RenderTooltipTitles {...props}/> :
                    <label className="form-addTicket-label w-f100">{props?.label} {props.data.structure.required && <span className="required">*</span>}</label>
                }
                {props?.isShowIconCopyFieldId && (
                    <Tooltip title={props?.data.id} placement='top' arrow>
                        <img
                            style={{paddingTop: '10px'}}
                            src="/assets/image/icon-copy.svg"
                            alt="copy"
                            onClick={() => navigator.clipboard.writeText(props?.data.id)}
                        />
                    </Tooltip>
                )}
            </div>
            
            <div className="form-addTicket-input">
                <div className="form-input-number">
                    {unitPosition &&
                        unitPosition === Constant.NUMBER_FIELD_DEFAULT.UNIT_POSITION_BEFORE && (
                            <div className="unit-number">{unit}</div>
                        )}
                    <div className="input-number">
                        <FormInputWithOnChange
                            type="number"
                            name={props?.name}
                            className="form-control-input form-control-wrapInput form-control-hg40"
                            variant="outlined"
                            autoComplete="off"
                            required={props?.required}
                            disabled={props.data.structure.publicForCustomer == 2 || props.viewFromProjectOfEscalateTicket || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false }
                            defaultValue={props?.defaultValue?.toString()?.length ? props.defaultValue : null}
                            errorlist={props?.errorlist}
                            onKeyPress={onKeyPress}
                            onPaste={handleOnPaste}
                            onChange={handleEditTicket}
                            isDisableOnBlur={props.isDisableOnBlur ? props.isDisableOnBlur : false}
                            integerOnly={integerOnly}
                        />
                    </div>
                    {unitPosition &&
                        unitPosition === Constant.NUMBER_FIELD_DEFAULT.UNIT_POSITION_AFTER && (
                            <div className="unit-number">{unit}</div>
                        )}
                </div>
            </div>
        </div>
    );
}

TextAreaInput.propTypes = {
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    ticketId: PropTypes.any,
    formType: PropTypes.any,
    detailTicket: PropTypes.any,
    data: PropTypes.any,
    name: PropTypes.any,
    isDraftMode: PropTypes.any,
    register: PropTypes.any,
    setValue: PropTypes.any,
    setIsEdited: PropTypes.any,
    setShowButtonEditTicket: PropTypes.any,
    listFieldEdited: PropTypes.any,
    setListFieldEdited: PropTypes.any,
    setOnChangeEdit: PropTypes.any,
    isDisableOnBlur: PropTypes.any,
    defaultValue: PropTypes.any,
    label: PropTypes.any,
    isTooltipTitle: PropTypes.any
};

function TextAreaInput(props) {
    let formType = props.formType;
    let defaultValue = '';
    const isAddNewTicket = !props?.detailTicket;
    const isFieldSDAutoScript = props?.data?.sysField === Constant.SYS_FIELD.SDAUTO_SCRIPT;
    const [isShowFlagMessage, setIsShowFlagMessage] = useState(false);
    let isTitleSdautoOnDraftMode = isFieldSDAutoScript && props?.isDraftMode;

    switch (true && !props.defaultValue) {
        case props.data.sysField === 'description' &&
            formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUESTDESK:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUESTDESK.DESCRIPTION;
            break;
        case props.data.sysField === 'description' && formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUEST.DESCRIPTION;
            break;
        case props.data.sysField === 'description' &&
            formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST_CUSTOMER:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUEST_CUSTOMER.DESCRIPTION;
            break;
        default:
            defaultValue = props?.defaultValue ? props?.defaultValue : '';
            break;
    }

    if (props.defaultValue) {
        defaultValue = props.defaultValue;
    }

    useEffect(() => {
        registerAndSetValue();
    }, []);

    useEffect(() => {
        registerAndSetValue();
    }, [defaultValue]);

    const registerAndSetValue = () => {
        if (!props?.name) {
            return;
        }

        if (props.register) {
            props.register(props?.name);
        }
        if (props.setValue) {
            props.setValue(props?.name, defaultValue);
        }
    };

    const handleEditTicket = e => {
        if (props?.setIsEdited) {
            props?.setIsEdited(true);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket()
            if(!props?.listFieldEdited?.includes(props?.name)){
                props?.setListFieldEdited([...props.listFieldEdited,props?.name])
            }
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
        }
    };

    const FlagMessageCopyLink = withStyles({
        tooltip: {
            color: '#1DA578',
            backgroundColor: '#D7F4E2',
            padding: '8px 16px',
            fontSize: '14px',
            boxShadow: '6px 5px 5px -4px rgba(0,0,0,0.3)'
        },
        arrow: {
            color: '#D7F4E2'
        }
    })(Tooltip);

    const getSDScriptS3Link = () => {
        const ticketDetail = props?.detailTicket;

        if (!ticketDetail || Utils.isEmptyObject(ticketDetail) || !ticketDetail?.id) return;

        let currentFieldId = props.name;
        if (!currentFieldId) return;

        let ticketId = ticketDetail.id
        if (ticketDetail.ticketType === Constant.TICKET_TYPE.BROADCAST_CHILD) {
            ticketId = ticketDetail.parent;
        }

        return Utils.generateS3LinkCodeSDScript(ticketId, currentFieldId)
    }

    const handleCopyLinkS3 = () => {
        let s3Link = getSDScriptS3Link();
        if (!s3Link) return;

        navigator.clipboard
            .writeText(s3Link)
            .then(() => {
                setIsShowFlagMessage(true);
                setTimeout(() => {
                    setIsShowFlagMessage(false);
                }, 1500);
            })
            .catch(err => {console.log(`handleCopyLinkSciptS3 err`, err)});
    }

    return (
        <div className="form-addTicket">
            <div className={`cell-prod-status gap-8 ${isTitleSdautoOnDraftMode ? 'div-title-sdauto cursor-default' : ''}`}>
                {props?.isTooltipTitle ? 
                    <RenderTooltipTitles {...props}/> :
                    <label className={`form-addTicket-label w-f100 ${isTitleSdautoOnDraftMode ? 'title-sdauto' : ''}`}>{props?.label} {props.data.structure.required && <span className="required">*</span>}</label>
                }
                {!isAddNewTicket && isFieldSDAutoScript && (
                    <div className={`${isTitleSdautoOnDraftMode ? '' : 'script-link'}`}>
                        <Tooltip title="リンクをコピー" arrow={true} placement="bottom">
                            <Button className="button-script cursor-pointer" onClick={handleCopyLinkS3}>
                                <FlagMessageCopyLink
                                    title={I18n.get('KNOWDEMSG002')}
                                    placement="top-start"
                                    arrow={true}
                                    open={isShowFlagMessage}
                                >
                                    <img src="/assets/image/html-link-icon.svg" alt="" className="cursor-pointer" />
                                </FlagMessageCopyLink>
                            </Button>
                        </Tooltip>
                    </div>
                )}
                {props?.isShowIconCopyFieldId && (
                    <Tooltip title={props?.data.id} placement='top' arrow>
                        <img
                            src="/assets/image/icon-copy.svg"
                            alt="copy"
                            onClick={() => navigator.clipboard.writeText(props?.data.id)}
                        />
                    </Tooltip>
                )}
            </div>
            <div className="form-addTicket-input">
                <FormInputWithOnChange
                    name={props?.name}
                    className={`form-control form-control-wrapTextarea ${isFieldSDAutoScript ? 'form-control-hg500' : 'form-control-hg112'}`}
                    variant="outlined"
                    defaultValue={defaultValue}
                    multiline
                    rows={4}
                    disabled={props.data.structure.publicForCustomer == 2 || props.viewFromProjectOfEscalateTicket || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false }
                    errorlist={props?.errorlist}
                    onChange={handleEditTicket}
                    data-cy="text-area-input-field"
                    isDisableOnBlur={props.isDisableOnBlur ? props.isDisableOnBlur : false}
                />
            </div>
        </div>
    );
}

IframeInput.propTypes = {
    defaultValue: PropTypes.any,
    flagReset: PropTypes.any,
    setFlagReset: PropTypes.any
};

function IframeInput(props) {
    const [src, setSrc] = useState(props?.defaultValue ? props?.defaultValue : '');
    let width = '100%';
    let height = '100%';

    const handleEditTicket = e => {
        if (props?.setIsEdited) {
            props?.setIsEdited(true);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket();
            if (!props?.listFieldEdited?.includes(props?.name)) {
                props?.setListFieldEdited([...props.listFieldEdited, props?.name]);
            }
            if (props?.setOnChangeEdit) {
                props?.setOnChangeEdit(!props.onChangeEdit);
            }
        }
    };

    const onChangeIframeURL = e => {
        let url = e.target.value;

        if (url && Constant.URL_REGEX.test(url)) {
            setSrc(url);
            props.setValue(props?.name, url);
            handleEditTicket(e);
            return;
        }
        // set url to blank
        if (!url) {
            props.setValue(props?.name, url);
            setSrc('');
            handleEditTicket(e);
        }
    };
    useEffect(() => {
        if (props?.defaultValue) {
            props.setValue(props?.name, props?.defaultValue);
        }
    }, []);

    useEffect(() => {
        setSrc(props?.defaultValue ? props?.defaultValue : '')
    },[props?.triggerReloadTicket])

    useEffect(() => {        
        if (props?.isDraftMode) {
            props.register(props?.name, {
                onChange: e => {}
            });
        
            props.setValue(props?.name, props?.defaultValue || '');
            setSrc(props?.defaultValue || '');
        }
    }, [props?.parentForm]);

    useEffect(() => {
        if (props?.flagReset) {
            setSrc(props?.defaultValue || '')
            props.setFlagReset(false);
        }
    }, [props?.flagReset, props?.defaultValue]);

    return (
        <div className="form-addTicket">
            <div className="cell-prod-status gap-8">
                {props?.isTooltipTitle ? 
                    <RenderTooltipTitles {...props}/> :
                    <label className="form-addTicket-label w-f100">{props?.label} {props.data.structure.required && <span className="required">*</span>}</label>
                }
                {props?.isShowIconCopyFieldId && (
                    <Tooltip title={props?.data.id} placement='top' arrow>
                        <img
                            style={{paddingTop: '10px'}}
                            src="/assets/image/icon-copy.svg"
                            alt="copy"
                            onClick={() => navigator.clipboard.writeText(props?.data.id)}
                        />
                    </Tooltip>
                )}
            </div>
            
            <div className="form-addTicket-input">
                <FormInputWithOnChange
                    name={props?.name}
                    className="form-control-input form-control-wrapInput form-control-hg40"
                    variant="outlined"
                    defaultValue={src}
                    autoComplete="off"
                    required={props?.required}
                    errorlist={props?.errorlist}
                    disabled={props.data.structure.publicForCustomer == 2 || props.viewFromProjectOfEscalateTicket || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false }
                    onChange={onChangeIframeURL}
                    isDisableOnBlur={props.isDisableOnBlur ? props.isDisableOnBlur : false}
                />
                { src && Constant.URL_REGEX.test(src) && <Iframe src={src} width={width} height={height} /> }
            </div>
        </div>
    );
}

URLInput.propTypes = {
    detailTicket: PropTypes.any,
    data: PropTypes.any,
    defaultValue: PropTypes.any
    // Add other props validations as needed
};

function URLInput(props) {
    const [rows, setRows] = useState(1);
    const isAddTicketPage = !props?.detailTicket || false;
    const handleEditTicket = e => {
        if (props?.setIsEdited) {
            props?.setIsEdited(true);
            if (props?.setShowButtonEditTicket) {
                props.setShowButtonEditTicket();
            }
            if (!props?.listFieldEdited?.includes(props?.name)) {
                const updatedList = [...props.listFieldEdited, props?.name];
                props?.setListFieldEdited(updatedList);
            }
            if (props?.setOnChangeEdit) {
                props?.setOnChangeEdit(!props.onChangeEdit);
            }
        }
        setURL(e.target.value);
    };
    const onChangeUrlInput = e => {
        if (!e.target.value) {
            setRows(1);
        }
        handleEditTicket(e);
    };

    const getDefaultValue = () => {
        if (isAddTicketPage) {
            return props?.defaultValue;
        }
        if (props?.isDraftMode) {
            return props?.defaultValue || '';
        }

        let currentDefaultValue = Array.isArray(props?.defaultValue) ? props?.defaultValue : [];

        if (typeof props?.defaultValue == 'string') {
            currentDefaultValue = [props?.defaultValue];
        }
        
        return currentDefaultValue;
    };

    const handleOnclickEdit = () => {
        setIsShowURL(false);
    }

    const handleOnApply = () => {
        if (!props?.errorlist.hasOwnProperty(props?.name)) {
            setIsShowURL(true);
        }
    }

    const handleOnReset = () => {
        props?.clearErrors(props?.name);
        let oldValue = '';
        if (Array.isArray(defaultValue)) {
            if (defaultValue.length == 1) {
                oldValue = defaultValue[0];
            } else {
                oldValue = defaultValue.join('\n');
            }
        }
        props?.setValue(props?.name, oldValue);
        setURL(defaultValue);
        setIsShowURL(true);
    }

    const isNotEditURL =
        props.data.structure.publicForCustomer == Constant.SETTING_FORM_DEFAULT.READ_ONLY
        || props.viewFromProjectOfEscalateTicket
        || !Utils.isEmptyString(props.detailTicket?.deletedAt)
        || props.hasEditFieldPermissions === false;
    const defaultValue = getDefaultValue();
    // const isAddTicketPage = !props?.detailTicket || false;
    const isEditTicketPage = !isAddTicketPage;
    const [valueURL, setURL] = useState(defaultValue);
    const [isShowURL, setIsShowURL] = useState(true);
    const updatedAt = props?.detailTicket?.updatedAt;
    const notError = !props?.errorlist.hasOwnProperty(props?.name);

    useEffect(() => {
        setIsShowURL(isEditTicketPage);
    }, []);

    useEffect(() => {
        setIsShowURL(notError && isEditTicketPage);
    }, [updatedAt]);

    
    useEffect(() => {    
        if (isAddTicketPage) {
            props.register(props?.name, {
                onChange: e => {}
            });
        
            props.setValue(props?.name, defaultValue || '');
            setURL(defaultValue || '')
        }

        let isKnowledgeForm = [Constant.FORM_TYPE.FORM_KNOWLEDGE, Constant.FORM_TYPE.FORM_MASTER].includes(props?.parentForm?.type);
        if (props?.isDraftMode || (props?.editTicket && !isKnowledgeForm)) {
            let oldValue = defaultValue; 
            if (Array.isArray(defaultValue)) {
                if (defaultValue.length == 1) {
                    oldValue = defaultValue[0];
                } else {
                    oldValue = defaultValue.join('\n');
                }
            }
            props.register(props?.name, {
                onChange: e => {}
            });
        
            props.setValue(props?.name, oldValue || '');
            setURL(oldValue || '');
        }
    }, [props?.parentForm]);

    const convertDataForTextArea = () => {
        let textAreaData = valueURL;
        if (Array.isArray(valueURL)) {
            if (valueURL.length == 1) {
                textAreaData = valueURL[0];
            } else {
                textAreaData = valueURL.join('\n');
            }
        }

        return textAreaData;

        
    }

    const convertTextAreaToArray = () => {
        let urlsArray = valueURL;
        let listUrl = []
        if (!Array.isArray(valueURL)) {
            urlsArray = valueURL.split('\n').map(url => url.trim()).filter(url => url !== '');
        }

        for (let index = 0; index < urlsArray.length; index++) {
            const url = urlsArray[index];

            const isShareLink = Utils.getShareLinkUrls(url)
            if(!Utils.isEmptyArray(isShareLink)){
                  listUrl.push({
                  value: url,
                  isShareLink: props?.onClickUrlViewTicket ? true : false
                  })  
            }else{
                  listUrl.push({
                  value: url,
                  isShareLink: false
                  })
            }
            
        }

        return listUrl;
    }

    useEffect(() => {
        if (props?.flagReset) {
            handleOnReset();
            props.setFlagReset(false);
        }
    }, [props?.flagReset, props?.defaultValue]);

    const showBoxURL = (isNotEditURL || isShowURL);
    return (
        <div className="form-addTicket form-field-url">
            <div className="cell-prod-status gap-8">
                {props?.isTooltipTitle ? 
                    <RenderTooltipTitles {...props}/> :
                    <label className="form-addTicket-label w-f100">{props?.label} {props.data.structure.required && <span className="required">*</span>}</label>
                }
                {props?.isShowIconCopyFieldId && (
                    <Tooltip title={props?.data.id} placement='top' arrow>
                        <img
                            style={{paddingTop: '10px'}}
                            src="/assets/image/icon-copy.svg"
                            alt="copy"
                            onClick={() => navigator.clipboard.writeText(props?.data.id)}
                        />
                    </Tooltip>
                )}
            </div>
            
            <div className="form-addTicket-input">
                <Box
                    style={{ display: showBoxURL ? 'block' : 'none' }}
                >
                    <Box display='inline-flex' sx={{ width: '100%' }}>
                        {
                            (valueURL && !Utils.isEmptyArray(valueURL))
                                ?
                                <Box className='field-url-link'>
                                    {
                                        convertTextAreaToArray(valueURL).map(url => (
                                            <> {url.isShareLink ? <Link
                                                onClick={e => props?.onClickUrlViewTicket(url.value)}
                                           >{url.value}</Link>:
                                                <Link
                                                    href={url.value}
                                                    target="_blank"
                                                >{url.value}</Link>
                                            }
                                                <br/>  
                                            </>
                                        ))
                                    }
                                </Box>
                                :
                                <TextField
                                    className="form-control form-control-wrapTextarea textarea-hg"
                                    value={''}
                                    disabled={true}
                                    variant="outlined"
                                    autoComplete="off"
                                />
                        }
                        {
                            !isNotEditURL &&
                            <Button
                                className="button-url cursor-default"
                                style={{ paddingRight: '0px' }}
                            >
                                <img src="/assets/image/button-url-edit.svg" alt="" className='cursor-pointer' onClick={handleOnclickEdit}/>
                            </Button>
                        }
                    </Box>
                </Box>
                <Box
                    style={{ display: !showBoxURL ? 'block' : 'none' }}
                >
                    <Box
                        display='flex'
                        sx={{ width: '100%' }}
                    >
                        <Box
                            sx={{ flexGrow: 1, paddingRight: '10px' }}
                        >
                            <TextAreaWithOnChange
                                name={props?.name}
                                className="form-control form-control-wrapTextarea textarea-hg"
                                variant="outlined"
                                rows={rows}
                                maxRows={4}
                                errorlist={props?.errorlist}
                                defaultValue={convertDataForTextArea()}
                                defaultValueReset={convertDataForTextArea()}
                                disabled={false}
                                onChange={e => onChangeUrlInput(e)}
                            />
                        </Box>
                        <Box display='inline-flex'>
                            <Button
                                className="button-url cursor-default"
                            >
                                <img src="/assets/image/button-url-apply.svg" alt="" className='cursor-pointer' onClick={handleOnApply}/>
                            </Button>
                            <Button
                                className="button-url cursor-default"
                                style={{ paddingRight: '0px' }}
                            >
                                <img src="/assets/image/button-url-reset.svg" alt="" className='cursor-pointer' onClick={handleOnReset}/>
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </div>
        </div>
    );
}

function ChipInput(props) {
    const chipValue = props.defaultValue || props.value || '';
    
    return (
        <div className="form-addTicket">
            <label className="form-addTicket-label">{props?.label}</label>
            <div className="form-addTicket-input">
                <div className="form-control-wrapInput form-control-hg40 chip-input-container">
                    {
                        !Utils.isEmptyString(chipValue) && 
                        <Tooltip title={chipValue} placement="top" arrow>
                            <div className="chip-input-wrapper">
                                <Chip
                                    label={chipValue}
                                    disabled={true}
                                    className="chip-input-chip"
                                />
                            </div>
                        </Tooltip>
                    }
                </div>
            </div>
        </div>
    );
}

const RenderFieldUI = props => {
    let formType = props.parentForm?.type;
    let fieldName = props?.data?.id;

    const generatePropsByMoreCondition = props => {
        let newProps = { ...props };
        //if you have more condition, let's refactor it.
        switch (props?.data?.sysField) {
            case Constant.SYSTEM_FIELD.BUSINESS_APP_USE_RANGE:{
                /**
                 * add new, duplicate screen we will reset to default value. but draft mode we keep values of ticket.
                 * https://docs.google.com/spreadsheets/d/1Dx8ynW25bf3-BGE5qxqzuh569awgFXTzZUBqaKdV_tk/edit?gid=1240861142#gid=1240861142&range=5:5
                 */
                if (props?.addTicket && props?.projectInuseDetail?.id && (!props?.isDraftMode || props?.isDuplicate)) {
                    newProps = {
                        ...newProps,
                        defaultValue: JSON.stringify([props?.projectInuseDetail?.id])
                    };
                }
                break
            }

            case Constant.SYSTEM_FIELD.AI_TELEPHONE_EXECUTION_SCOPE:
                if (
                    props?.addTicket && 
                    props?.projectInuseDetail?.id !== props?.detailTicket?.affiliationProject && 
                    (!props?.isDraftMode || props?.isDuplicate) && 
                    !Utils.isPublicDesk(props?.projectInuseDetail)
                ) {
                    newProps = {
                        ...newProps,
                        defaultValue: JSON.stringify([])
                    };
                }
                break;
            case Constant.SYSTEM_FIELD.ATTACHMENTS:{
                if(Utils.isSystemBusinessAppForm(props?.parentForm)){
                    newProps = {
                        ...newProps,
                        acceptedFileExtensions: Constant.BUSINESS_APP_ALLOW_FILE_EXTENSIONS,
                        allowMultipleFiles: false,
                        limitFileSize: 1, //MB
                        note: I18n.get('NOTE-ATTACH-FILE')
                    };
                }
                break
            }
            default:
        }
        return newProps;
    };

    switch (props.UI) {
        case Constant.FIELD_UI.TEXT:
            return <TextInput {...props} formType={formType} fieldName={fieldName} />;
        case Constant.FIELD_UI.NUMBER:
            return <NumberInput {...props} />;
        case Constant.FIELD_UI.TEXT_AREA:
            return <TextAreaInput {...props} formType={formType} fieldName={fieldName} />;
        case Constant.FIELD_UI.DROP_FILE:
            if (props.editTicket) {
                return <EditFileUploaded {...(generatePropsByMoreCondition(props))} />;
            }
            return <DropFile {...props} />;
        case Constant.FIELD_UI.TAG:
            if (
                props.data?.sysField === 
                TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_STATUS
            ) {
                return <TelephoneCallStatusFieldUI {...props} />;
            }
            const isMasterKnowledge = [
                Constant.SETTING_SELECT_ITEM_TAG_FIELD.MASTER_KNOWLEDGE
            ].includes(props.data?.structure?.settingSelectItem);
            
            if (isMasterKnowledge) {
                if (props?.isNotAuthen) {
                    return <MenuMasterKnowledgeTagInPutNotAuthen {...props}/>
                }
                return <MenuMasterKnowledgeTagInPutWithAuthen {...props} />
            }
            if (props?.isNotAuthen) {
                return <MenuTagInputNotAuthen {...props}/>
            }
            return <MenuTagInPutWithAuthen {...(generatePropsByMoreCondition(props))} />
        case Constant.FIELD_UI.DATE:
            if (props.data.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_DATE) {
                return <AITelephoneStartDatePicker {...props} />;
            }
            if (props.data.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_END_DATE) {
                return <AITelephoneEndDatePicker {...props} />;
            }
            return <DataPickerInput {...props} />;
        case Constant.FIELD_UI.IFRAME:
            return <IframeInput {...props} />;
        case Constant.FIELD_UI.URL:
            if (props.data.sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CHILD_LINK) {
                return null;
            }
            if (
                props.data.sysField === 
                TelephoneConstant.TELEPHONE.SYSTEM_FIELD.AI_OPERATOR_PROMPT
            ) {
                return <ChipInput {...props} />;
            }
            return <URLInput {...props} />;
        case Constant.FIELD_UI.FIELD_RICHTEXT:
            return <RichTextEditor {...props} />;
        case Constant.FIELD_UI.SELECTOR:
            // Handle telephone call status field with special UI
            if (
                props.data?.sysField === 
                TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_STATUS
            ) {
                return <TelephoneCallStatusFieldUI {...props} />;
            }
            return <StatusFieldUI {...props}/>;
        case Constant.FIELD_UI.MERMAID:
            return <MermaidFieldUI {...props} />;
        case Constant.FIELD_UI.HTML:
            return <HtmlFieldUI {...props} />;
        case Constant.FIELD_UI.MARKDOWN:
            return <MarkdownFieldUI {...props} />;
        // For create email ticket
        case Constant.FIELD_UI.TEXT_WITH_CHIP:
            switch (props?.data?.definition) {
                case Constant.FORM_DEFINITION.SYSTEM:
                    if(props?.data?.type ===  Constant.FORM_TYPE.FIELD_TAG) return <MenuTagInPutWithAuthen {...(generatePropsByMoreCondition(props))}/>
                    return (
                        <TextInputWithChip
                            {...props}
                            setIsEdited={props?.setIsEdited}
                            listSuggestSearchEmail={props.listSuggestSearchEmail || []}
                        />
                    );
                default:
                    return (
                        <TextInputWithChip
                            {...props}
                            setIsEdited={props?.setIsEdited}
                            listSuggestSearchEmail={props.listSuggestSearchEmail || []}
                        />
                    );
            }
        default:
            return null;
    }
};
export default RenderFieldUI;
